import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListCustomerCell } from './channel-list-customer.cell';
import { ChannelListCustomerHeader } from './channel-list-customer.header';

export const ChannelListCustomerColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['customer']
> = {
  enableSorting: false,
  header: ChannelListCustomerHeader,
  cell: ChannelListCustomerCell,
};
